import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector: 'auth-log-in',
    templateUrl: './log-in.component.html',
})
export class AuthLogInComponent implements OnInit {
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _authService: AuthService,
        private _router: Router
    ) {
    }

    private _redirectURL: string;

    logInForm: FormGroup;
    stage: 'phone' | 'otp';

    @ViewChild('otpInput') otpInput: ElementRef;

    ngOnInit(): void {
        let paramMap = this._activatedRoute.snapshot.queryParamMap;
        this._redirectURL = paramMap.get('redirectUrl') || '/signed-in-redirect';
        let token = paramMap.get('token');
        if (this._authService.accessToken !== '') {
            this._onLogIn();
        } else if (token) {
            this._authService.accessToken = token;
            this._onLogIn();
        } else {
            this.logInForm = new FormGroup({
                phone: new FormControl<string>(undefined, [
                    Validators.required,
                    Validators.maxLength(10),
                    Validators.minLength(10),
                ]),
                otp: new FormControl<string>(undefined),
            });
            this.stage = 'phone';
        }
    }

    logIn(): void {
        if (this.logInForm.invalid) {
            return;
        }
        this.logInForm.disable();
        if (this.stage === 'phone') {
            this._authService
                .sendOTP(this.logInForm.get('phone').value)
                .subscribe((response: any) => {
                    if (response) {
                        this.logInForm.enable();
                        this.stage = 'otp';
                        setTimeout(() => {
                            this.otpInput.nativeElement.focus();
                        }, 1000);
                    }
                });
        } else {
            this._authService
                .verifyOTP(
                    this.logInForm.get('phone').value.toString(),
                    this.logInForm.get('otp').value.toString()
                )
                .subscribe((response: any) => {
                    if (response) {
                        this._onLogIn();
                    } else {
                        this.logInForm.reset();
                        this.logInForm.enable();
                        this.stage = 'phone';
                    }
                });
        }
    }

    private async _onLogIn() {
        // Set the redirect url.
        // The '/signed-in-redirect' is a dummy url to catch the request and redirect the user
        // to the correct page after a successful sign in. This way, that url can be set via
        // routing file and we don't have to touch here.
        console.log('_onLogIn redirecting', this._redirectURL);
        // Navigate to the redirect url
        await this._router.navigateByUrl(this._redirectURL)
    }
}
